import { useQuery } from 'react-query';

import { getJobsPostingsRoute, jobPostingsKey } from '@features/jobPostings';
import axiosInstance from '@server/axiosInstance';

export const useGetJobPostings = (company_id?: number | string | null) => {
  const {
    data: jobPostingsData,
    isLoading: isLoadingJobPostings,
    isError: isErrorJobPostings,
    isFetched: isFetchedJobPostings,
  } = useQuery({
    queryKey: [jobPostingsKey, company_id],
    queryFn: () =>
      axiosInstance
        .post(getJobsPostingsRoute, { company_id })
        .then((res) => res.data),
    enabled: company_id !== null,
    refetchOnWindowFocus: false,
  });

  return {
    jobPostingsData,
    isLoadingJobPostings,
    isErrorJobPostings,
    isFetchedJobPostings,
  };
};
